import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default Vue.component('dynamic-page-select', {
  template: require('./template.html'),
  name: 'dynamic-page-select',
  computed: {
    ...mapGetters(['currentSite']),
    allPages() {
      const range = [{ name: 'No Link' }, { name: 'Custom Link' }];
      const pages = this.currentSite.pages;
      _.forEach(pages, (page) => {
        range.push({
          _id: page._id,
          name: page.name,
          url: page.url,
        });
      });

      const search = new RegExp(this.searchPages, 'gi');
      return _.filter(range, p => p.name.match(search));
    },
  },
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-tab',
    'open-cropper',
  ],
  data() {
    return {
      searchPages: '',
      pageLink: '',
      customLink: '',
      modal: false,
      showPages: false,
    };
  },
  watch: {
    innerTabs: {
      handler(tab) {
        if (tab[this.dynamicTab]) {
          this.setInitialValues();
        }
      },
      deep: true,
    },
  },
  methods: {
    setInitialValues() {
      this.pageLink = this.getPageLink();
      this.customLink = this.activeItem.customLink || '';
      this.modal = this.activeItem.modal;
    },
    updatePageLink(page) {
      let pagelink = false;
      this.pageLink = page.name;
      if (page.name === 'Custom Link') {
        pagelink = this.getInputVal(this.customLink);
      }
      if (page._id) {
        pagelink = page._id;
      }
      this.$store.dispatch('setDropletVal', {
        drp: this.activeItem,
        key: 'pageLink',
        val: pagelink,
      });
      this.showPages = false;
    },
    updateCustomLink(link) {
      const val = this.getInputVal(link);
      this.$store.dispatch('setDropletVal', {
        drp: this.activeItem,
        key: 'pageLink',
        val,
      });
      this.$store.dispatch('setDropletVal', {
        drp: this.activeItem,
        key: 'customLink',
        val,
      });
    },
    getPageLink() {
      if (!this.activeItem) {
        return 'No Link';
      }
      const currentPageLink = this.activeItem.pageLink;
      let link = '';
      if (!currentPageLink) {
        link = 'No Link';
      }
      const pageId = new RegExp(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/, 'i');
      if (typeof currentPageLink === 'string') {
        if (currentPageLink.match(pageId) && !currentPageLink.match(/^#modal-/i)) {
          const page = _.find(this.allPages, p => p._id === currentPageLink);
          if (page) {
            link = page.name;
          } else {
            link = 'No Link';
          }
        } else {
          link = 'Custom Link';
        }
      }
      return link;
    },
    getInputVal(val) {
      return val.trim() !== '' ? val : false;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/page-select/index.js